import { render, staticRenderFns } from "./RecipientItem.vue?vue&type=template&id=4e541ccd"
import script from "./RecipientItem.ts?vue&type=script&lang=ts&external"
export * from "./RecipientItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports